module.exports = __webpack_public_path__ + "img/trial1-4.edf180a9.png";